import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_252 implements Validator {

	public static id = 'CTRL_252';
	private message = 'error.ctr_252';

	public LOG: LogService = new LogService(CTRL_252);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map, autoCompleteService: any) {

		// vérifier si la règle est applicable sur le formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_252.id + '_');

		let cpv = autoCompleteService.cpv;

		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				ctrl.value.rgCtrls.listObjetComplementaire.forEach(element => {
					if (!cpv.map(cpv => cpv.code).includes(form.controls[map.get(element)].value)) {
						// placer le message d'erreur
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
					} else {
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
					}
				});
			}
		}
	}
}
